<template>
	<div>
		<v-layout row wrap>
			<v-flex xs12 text-xs-left>
				<v-layout wrap align-center justify-space-between>
					<v-flex xs12 sm6>
						<label class="label-title">Datos de venta</label>
					</v-flex>
					<v-flex xs12 sm6 text-xs-right>
						<v-layout wrap justify-end>
							<v-flex xs2 text-xs-right pr-2
								v-if="isQuotation"
							>
								<v-btn dark fab icon small info
									class="mr-2 btn-ticket"
									v-tooltip:left="{ html: 'Imprimir Comanda' }"
									@click="downloadTicket"
								>
									<v-icon>cloud_download</v-icon>
								</v-btn>
							</v-flex>
							<v-flex xs2 text-xs-right pr-2 v-if="sale.typeDocument.name !== 'COTIZACION'" >
								<v-btn dark fab icon small info class="mr-2"
									v-tooltip:left="{ html: 'Descargar Venta' }"
									@click="downloadSale"
								>
									<v-icon>cloud_download</v-icon>
								</v-btn>
							</v-flex>
							
							<v-flex xs2 pr-2 text-xs-right v-if="sale.typeDocument.name === 'COTIZACION'">
								<v-btn 
								@click="downloadQuotation"
								dark fab icon small info class="mr-4"
								v-tooltip:left="{ html: 'Descargar Cotización' }">
									<v-icon>cloud_download</v-icon>
								</v-btn>
							</v-flex>

							<v-flex xs2 text-xs-right pr-3 v-if="sale.typeDocument.name !== 'COTIZACION'">
								<v-btn dark fab icon small warning class="mr-2"
									v-tooltip:left="{ html: 'Descargar Venta por Categorias' }"
									@click="downloadSaleCategory"
								>
									<v-icon>donut_small</v-icon>
								</v-btn>
							</v-flex>
							<v-flex xs2 v-if="showDownloadBtn" text-xs-right px-0>
								<v-layout wrap justify-end pr-3>
									<v-flex xs6 px-0>
										<v-btn dark fab icon warning small
											v-tooltip:left="{ html: 'Descargar ZIP' }"
											@click="openDownloadView('zip')">
											<v-icon>receipt</v-icon>
										</v-btn>
									</v-flex>
								</v-layout>
							</v-flex>

							<v-flex xs2 v-if="showDownloadBtn" flex xs-2 text-xs-right pr-2>
								<v-layout wrap justify-end pr-3>
									<v-flex xs5 px-0>
										<v-btn dark fab icon warning small
											v-tooltip:left="{ html: 'Descargar ZIP' }"
											@click="openDownloadView('zip')"
										>
											<v-icon>receipt</v-icon>
										</v-btn>
									</v-flex>
								</v-layout>
							</v-flex>

						</v-layout>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 mt-2>
				<div class="bar-data">
					<div class="bar-data-item">
						<p>
							Nº Doc:
							<span>{{ sale.numDocument }}</span>
						</p>
					</div>
					<div class="bar-data-item">
						<p>
							Sucursal:
							<span>{{ sale.sucursalName }}</span>
						</p>
					</div>
					<div class="bar-data-item">
						<p>
							Cliente:
							<span>{{ customer.typePerson.fullName }}</span>
						</p>
					</div>
					<div class="bar-data-item">
						<p>
							{{ customer.typePerson.documentName }}:
							<span>{{ customer.typePerson.documentNumber }}</span>
						</p>
					</div>
					<div class="bar-data-item">
						<p>
							Modo de pago:
							<span>{{ sale.payment.name }}</span>
						</p>
					</div>
					<div class="bar-data-item">
						<p>
							Tipo de Doc:
							<span>{{ sale.typeDocument.name }}</span>
						</p>
					</div>
					<div class="bar-data-item no-border">
						<p>
							Fecha:
							<span>{{ sale.localDate.date | parseDate }}</span>
						</p>
					</div>
				</div>
			</v-flex>
			<v-flex xs12 mt-3 text-xs-left
				v-show="sale.commentary">
				<label class="label-title">Observación:</label>
				<v-text-field
					class="input-border-inset input-textarea input-note mt-2"
					no-resize
					multi-line
					:rows="2"
					textarea
					readonly
					:value="sale.commentary"
				></v-text-field>
			</v-flex>
		</v-layout>
		<table-run
			class="no-selectable-table mt-3"
			:columns="columns"
			:rows="rows"
			:selectable="false"
			:include-search="false"
			:include-delete="false"
			:include-export-to-excel="false"
		>
			<template slot="rows" scope="props">
				<td>{{ props.row.createdAt | parseDate }}</td>
				<td>{{ props.row.productCode }}</td>
				<td>{{ props.row.categoryName }}</td>
				<td>{{ props.row.productName }}</td>
				<td>{{ props.row.quantity }}</td>
				<td>{{ props.row.price | round | currency(symbol) }}</td>
				<td>{{ props.row.subTotal | round | currency(symbol) }}</td>
			</template>
		</table-run>
		<v-layout row wrap px-1 mb-5>
			<v-flex xs12 sm6>
				<v-layout
					row wrap
					class="footer-bar-grey"
				>
					<v-flex xs4>
						<v-subheader class="justify-center footer-bar-title">
							Cargo al Consumo
						</v-subheader>
						<p class="footer-bar-title">{{ sale ? sale.tip : '' | round | currency(symbol) }}</p>
					</v-flex>
					<v-flex xs1>
						<v-subheader
						class="footer-bar-title">
							+
						</v-subheader>
					</v-flex>
					<v-flex xs3>
						<v-subheader
							class="justify-center footer-bar-title"
						>
							Subtotal
						</v-subheader>
						<p class="footer-bar-content">{{ sale.subtotal | round | currency(symbol) }}</p>
					</v-flex>
					<v-flex xs1>
						<v-subheader
							class="footer-bar-title"
						>
							+
						</v-subheader>
					</v-flex>
					<v-flex xs3>
						<v-subheader
							class="justify-center footer-bar-title"
						>
							IGV
						</v-subheader>
						<p class="footer-bar-content">{{ sale.taxes | round | currency(symbol) }}</p>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 sm6>
				<v-layout row wrap>
					<v-flex
						xs5
						class="footer-bar-white"
					>
						<v-subheader
							class="justify-center footer-bar-title blue"
						>
							-dsct
						</v-subheader>
						<p class="footer-bar-content">{{ sale.discount | round | currency(symbol) }}</p>
					</v-flex>
					<v-flex
						xs7
						class="footer-bar-blue"
					>
						<v-subheader
							class="justify-center footer-bar-title white"
						>
							Total
						</v-subheader>
						<p class="footer-bar-title white">{{ sale.amount | round | currency(symbol) }}</p>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout row wrap justify-center>
			<v-flex xs2 text-xs-center>
				<v-btn
					class="btn-save"
					@click="goToBack"
				>
					Regresar
				</v-btn>
			</v-flex>
		</v-layout>
		<v-dialog v-model="dialog" persistent>
			<v-card>
				<v-card-title class="headline">
					¿Desea anular la venta?
				</v-card-title>
				<v-card-actions class="justify-center">
					<v-btn
						class="btn-add btn-grey mr-2"
						@click.native="closeConfirm">
						Cancelar
					</v-btn>
					<v-btn
						class="btn-add"
						@click.native="cancelSale">
						Aceptar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import TableRun from 'table-run';
	import helper from '@/shared/helper';
	import mixin from '@/shared/mixins';
	import { currency, parseDate, round } from '@/shared/filters';

	const helperMethods = helper.methods;

	function created() {
		this.loadData();
	}

	async function cancelSale() {
		const cancelModel = {
			commentary: '',
			subsidiaryId: this.sale.idSubsidiary,
		};
		await this.$http.patch(`${process.env.PMS_URL}/point/${this.id}/document`,
			cancelModel);
		this.showNotification('La venta se anuló correctamente.', 'success');
		this.closeConfirm();
		this.goToBack();
	}

	function closeConfirm() {
		this.dialog = false;
	}

	async function downloadQuotation() {
		const id = this.id;
		const serie = `${this.sale.serie}-${this.sale.number}`;
		const model = { code: 'pdf' };
		const responseType = 'blob';
		const params = { documentId: id };
		const response = await this.$http.post(`${process.env.PMS_URL}/report/accountStatus`, model, { params, responseType });
		const blob = helperMethods.generateBlob(response.data);
		helperMethods.showDownloadDialog(blob, serie, 'pdf');
	}
	
	async function downloadSaleCategory() {
		const id = this.id;
		const serie = `${this.sale.serie}-${this.sale.number}`;
		const model = { code: 'pdf-categories' };
		const responseType = 'blob';
		const response = await this.$http.post(`${process.env.SALES_URL}/p/sale-documents/${id}/pdf`,
			model, { responseType });
		const blob = helperMethods.generateBlob(response.data);
		helperMethods.showDownloadDialog(blob, serie, 'pdf');
	}

	async function downloadSale() {
		const id = this.id;
		const serie = `${this.sale.serie}-${this.sale.number}`;
		const model = { code: 'pdf' };
		const responseType = 'blob';
		const response = await this.$http.post(`${process.env.SALES_URL}/p/sale-documents/${id}/pdf`,
			model, { responseType });
		const blob = helperMethods.generateBlob(response.data);
		helperMethods.showDownloadDialog(blob, serie, 'pdf');
	}

	async function downloadTicket() {
		const urlBase = `${process.env.PMS_URL}/report/command-preview`;
		const query = `?format=tabloid&recipe=html-with-browser-client&documentId=${this.id}`;
		const serie = `${this.sale.serie}-${this.sale.number}`;
		const response = await this.$http.post(
			`${urlBase}${query}`,
		);
		const blob = helperMethods.generateBlob(response.bodyText);
		helperMethods.showDownloadDialog(blob, serie, 'html');
	}

	function goToBack() {
		this.$router.push({ name: 'sales-list' });
	}

	async function loadData() {
		const { data: sale } = await this.$http.get(`${process.env.PMS_URL}/point/${this.id}/document`);
		sale.data.customer.fullName = `${sale.data.customer.name} ${sale.data.customer.lastname}`;
		sale.data.customer.documentType = sale.data.customer.flagTypePerson === 1 ? 'DNI' : 'RUC';
		sale.data.customer.documentNumber = sale.data.customer.flagTypePerson === 1 ?
			sale.data.customer.dni : sale.data.customer.ruc;
		sale.data.numDocument = sale.data.serie && sale.data.number ? `${sale.data.serie}-${sale.data.number}`
			: '';
		sale.data.sucursalName = sale.data.subsidiary ? sale.data.subsidiary.sucursalName : '';
		this.flagTaxes = sale.data.subsidiary && sale.data.subsidiary.flagTaxes;
		this.customer = sale.data.customer;
		this.rows = sale.data.details.map((row) => {
			const newRow = { ...row };
			newRow.productCode = row.product.code;
			newRow.productName = row.product.name;
			newRow.categoryName = row.product.category.name;
			return newRow;
		});
		this.sale = sale.data;
	}

	function openDownloadView(type) {
		const rucSubsidiary = this.sale.subsidiary.ruc;
		const typeDoc = this.sale.typeDocument.code === 'BOL' ? 'BB' : 'FF';
		const serie = this.sale.serie;
		const number = this.sale.number;
		const codeTaxes = this.sale.typeDocument.codeTaxes;
		const url = `${process.env.SUNAT_URL}/admin/download/${rucSubsidiary}/document/${typeDoc}${serie}-${number}/typeDocument/${codeTaxes}/${type}`;
		window.open(url, '_blank');
	}

	function saleFinished() {
		return this.sale.state.code !== 'FIN';
	}

	function showDownloadBtn() {
		const saleDocumentValid = this.sale.typeDocument.code === 'FAC'
			|| this.sale.typeDocument.code === 'BOL';
		return this.flagTaxes && saleDocumentValid;
	}

	function symbol() {
		return this.sale.currencySymbol;
	}

	function isQuotation() {
		return this.sale.typeDocument.code === 'COT';
	}

	function data() {
		return {
			columns: [
				{ id: 1, name: 'Fecha' },
				{ id: 2, name: 'Cod. Producto' },
				{ id: 3, name: 'Categoría' },
				{ id: 4, name: 'Nombre Producto' },
				{ id: 5, name: 'Cant.' },
				{ id: 6, name: 'Precio Producto' },
				{ id: 7, name: 'Total' },
			],
			customer: {
				typePerson: {
					fullName: '',
					documentNumber: '',
				},
			},
			dialog: false,
			flagTaxes: 0,
			rows: [],
			sale: {
				localDate: {},
				payment: {},
				state: {},
				subsidiary: {},
				typeDocument: {},
				tip: {},
			},
		};
	}

	export default {
		name: 'sale-detail',
		components: {
			TableRun,
		},
		computed: {
			isQuotation,
			showDownloadBtn,
			saleFinished,
			symbol,
		},
		created,
		data,
		filters: {
			currency,
			parseDate,
			round,
		},
		methods: {
			downloadSaleCategory,
			cancelSale,
			closeConfirm,
			downloadSale,
			downloadTicket,
			goToBack,
			loadData,
			openDownloadView,
			downloadQuotation,
		},
		mixins: mixin,
		props: {
			id: {
				required: true,
				type: [Number, String],
			},
		},
	};
</script>

<style lang="scss" scoped>
	.bar-data {
		align-items: center;
		background-color: white;
		box-shadow: 0 2px 5px 0 rgba($color: #000000, $alpha: .1);
		display: flex;
		height: 48px;
		justify-content: space-around;

		&-item {
			border-right: 1px solid map-get($colors, year-select);
			flex: 1 auto;

			&:last-of-type {
				border-right: 0px;
			}

			&.no-border {
				border-right: 0px;
			}

			p {
				color: map-get($colors, bg-chart);
				font-family: map-get($fonts, medium);
				font-size: map-get($sizes, fourteen);
				margin-bottom: 0px;

				span {
					color: map-get($colors, realtime-label);
					font-family: map-get($fonts, regular);
					font-size: map-get($sizes, fourteen);
					text-transform: capitalize;
				}
			}
		}

		.bar-icon {
			font-size: map-get($map: $sizes, $key: twenty);
			justify-content: flex-start;
			width: 20px;
		}
	}

	.footer-bar {
		&-title {
			color: map-get($colors, label-sales);
			font-family: map-get($fonts, bold);

			&.blue {
				background-color: map-get($colors, white) !important;
				border-color: map-get($colors, white) !important;
				color: map-get($colors, bg-chart);
			}

			&.white {
				background-color: map-get($colors, bg-chart) !important;
				border-color: map-get($colors, bg-chart) !important;
				color: map-get($colors, white);
			}
		}

		&-grey {
			background-color: map-get($colors, divider);
		}

		&-white {
			background-color: map-get($colors, white);
		}

		&-blue {
			background-color: map-get($colors, bg-chart) !important;
		}

		&-content {
			color: map-get($colors, label-bold);
			font-family: map-get($fonts, semibold);
		}
	}

	.btn-ticket {
		background-color: map-get($colors, default-green) !important;
	}

	.btn-categories {
		background-color: red;
	}
</style>




// WEBPACK FOOTER //
// Detail.vue?62231df9